import script from "./DatasetDeleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetDeleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./DatasetDeleteDialog.vue?vue&type=style&index=0&id=abacd978&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abacd978"]])

export default __exports__